import type { OnboardingCardBinding } from '../services/funnels';

export type OnboardingTemplateDesign = {
  templateName: string;
  theme: string;
  styleSheet: string;
  palette: string;
  primaryColor: string;
  secondaryColor: string;
  coverStyle: string;
};

export type OnboardingTemplateOption = {
  id: string;
  baseTemplateId: string;
  templateDbId: number;
  templateType: string;
  templateFamily: string;
  name: string;
  description: string;
  previewUrl: string | null;
  thumbnailUrl: string | null;
  isStyleVariant: boolean;
  kind: 'html' | 'image' | 'element';
  design?: OnboardingTemplateDesign;
  isBrandBase?: boolean;
  brandLogoUrl?: string | null;
  brandName?: string;
};

export const getOnboardingBindingOptionId = (binding: Pick<OnboardingCardBinding, 'family_key' | 'binding_key'>) =>
  `${binding.family_key}:${binding.binding_key}`;

export const buildOnboardingOptionsFromBindings = (
  bindings: OnboardingCardBinding[],
): OnboardingTemplateOption[] =>
  bindings
    .filter(binding => binding.kind === 'html' || binding.kind === 'image')
    .map(binding => {
      const isHtml = binding.kind === 'html';
      return {
        id: getOnboardingBindingOptionId(binding),
        baseTemplateId: binding.family_key,
        templateDbId: binding.id,
        templateType: binding.family_key,
        templateFamily: binding.family_key,
        name: binding.display_name,
        description: binding.description ?? '',
        previewUrl: binding.preview_url || null,
        thumbnailUrl: binding.thumbnail_url || binding.preview_url || null,
        isStyleVariant: isHtml,
        kind: binding.kind,
        design: isHtml
          ? {
              templateName: binding.display_name,
              theme: binding.style_id,
              styleSheet: binding.style_id,
              palette: binding.palette_fallback,
              primaryColor: '#FFFFFF',
              secondaryColor: '#FFFFFF',
              coverStyle: 'template_studio_html',
            }
          : undefined,
      };
    });
